import { render, staticRenderFns } from "./modalDetailMemberApproval.vue?vue&type=template&id=a3f90f10&scoped=true"
import script from "./modalDetailMemberApproval.vue?vue&type=script&lang=js"
export * from "./modalDetailMemberApproval.vue?vue&type=script&lang=js"
import style0 from "./modalDetailMemberApproval.vue?vue&type=style&index=0&id=a3f90f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f90f10",
  null
  
)

export default component.exports